import React from 'react';
import { Container, Typography, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import './WebTechStack.css';

const techCategories = [
  {
    title: 'Frontend Development',
    description: 'Modern and responsive user interfaces',
    technologies: [
      { name: 'React.js', image: '/assets/tech-logos/react.png' },
      { name: 'Next.js', image: '/assets/tech-logos/nextjs.png' },
    //   { name: 'Vue.js', image: '/assets/tech-logos/vue.png' },
    //   { name: 'Angular', image: '/assets/tech-logos/angular.png' },
      { name: 'TypeScript', image: '/assets/tech-logos/typescript.png' },
      { name: 'Tailwind CSS', image: '/assets/tech-logos/tailwind.png' },
      { name: 'JavaScript', image: '/assets/tech-logos/javascript.png' }
    ]
  },
  {
    title: 'Backend Development',
    description: 'Scalable and secure server solutions',
    technologies: [
      { name: 'Node.js', image: '/assets/tech-logos/nodejs.png' },
      { name: 'Python', image: '/assets/tech-logos/python.png' },
      { name: 'PHP', image: '/assets/tech-logos/php.png' },
      // { name: 'Java', image: '/assets/tech-logos/java.svg' },
    //   { name: 'Go', image: '/assets/tech-logos/go.png' },
    //   { name: '.NET', image: '/assets/tech-logos/dotnet.png' }
    ]
  },
  {
    title: 'Database Solutions',
    description: 'Reliable data storage and management',
    technologies: [
      { name: 'MongoDB', image: '/assets/tech-logos/mongodb.png' },
    //   { name: 'PostgreSQL', image: '/assets/tech-logos/postgresql.png' },
      { name: 'MySQL', image: '/assets/tech-logos/mysql.png' },
    //   { name: 'Redis', image: '/assets/tech-logos/redis.png' },
      { name: 'Firebase', image: '/assets/tech-logos/firebase.png' },
      { name: 'GraphQL', image: '/assets/tech-logos/graphql.png' }
    ]
  },
  {
    title: 'DevOps & Deployment',
    description: 'Seamless deployment and scaling',
    technologies: [
      { name: 'Docker', image: '/assets/tech-logos/docker.png' },
      { name: 'AWS', image: '/assets/tech-logos/aws.png' },
      { name: 'Google Cloud', image: '/assets/tech-logos/gcp.png' },
    //   { name: 'Azure', image: '/assets/tech-logos/azure.png' },
      { name: 'Kubernetes', image: '/assets/tech-logos/kubernetes.png' },
      { name: 'Jenkins', image: '/assets/tech-logos/jenkins.png' }
    ]
  }
];

const WebTechStack = () => {
  return (
    <section className="web-tech-stack">
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="tech-stack-header"
        >
          <Typography variant="h2" className="tech-stack-title">
            Our Technology Stack
          </Typography>
          <Typography variant="subtitle1" className="tech-stack-subtitle">
            Cutting-edge technologies for modern web solutions
          </Typography>
        </motion.div>

        <Grid container spacing={4}>
          {techCategories.map((category, categoryIndex) => (
            <Grid item xs={12} md={6} key={categoryIndex}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: categoryIndex * 0.1 }}
              >
                <Paper className="tech-category">
                  <Typography variant="h5" className="web-category-title">
                    {category.title}
                  </Typography>
                  <Typography variant="body1" className="web-category-description">
                    {category.description}
                  </Typography>
                  <Grid container spacing={2} className="tech-grid">
                    {category.technologies.map((tech, techIndex) => (
                      <Grid item xs={4} sm={4} key={techIndex}>
                        <motion.div
                          className="tech-item"
                          whileHover={{ scale: 1.05 }}
                          transition={{ type: "spring", stiffness: 300 }}
                        >
                          <img
                            src={tech.image}
                            alt={tech.name}
                            className="tech-logo"
                          />
                          <Typography variant="body2" className="tech-name">
                            {tech.name}
                          </Typography>
                        </motion.div>
                      </Grid>
                    ))}
                  </Grid>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
};

export default WebTechStack; 